import HoldingAttributesSelector from './HoldingAttributesSelector';

export default HoldingAttributesSelector;
